/**
 * Public site header navigation (must stay in sync with php_backend MenuController::buildPublicNavigationMenu).
 */
export const PUBLIC_NAV_MENU = [
  { key: 'home', label: 'Home' },
  {
    key: 'about',
    label: 'About Us',
    submenu: [
      { key: 'leadership-message', label: 'Leadership Message' },
      { key: 'vision', label: 'Vision & Mission' },
      { key: 'infrastructure', label: 'Infrastructure' },
      { key: 'staff', label: 'Our Staff' },
    ],
  },
  {
    key: 'academics',
    label: 'Academics',
    submenu: [
      { key: 'curriculum', label: 'Curriculum' },
      { key: 'assessment', label: 'Assessment' },
      { key: 'admissions', label: 'Admissions' },
      { key: 'fees', label: 'Fee Structure' },
      { key: 'timetable', label: 'Timetable' },
      { key: 'faq', label: 'FAQ' },
    ],
  },
  {
    key: 'student-life',
    label: 'Student Life',
    submenu: [
      { key: 'activities', label: 'Activities' },
      { key: 'sports', label: 'Sports' },
      { key: 'achievements', label: 'Achievements' },
      { key: 'testimonials', label: 'Testimonials' },
    ],
  },
  {
    key: 'news-events',
    label: 'News & Events',
    submenu: [
      { key: 'news', label: 'Latest News' },
      { key: 'events', label: 'School Events' },
      { key: 'gallery', label: 'Photo Gallery' },
      { key: 'downloads', label: 'Downloads' },
    ],
  },
  { key: 'contact', label: 'Contact' },
];

/** Map DB setting key (MENU_*) to canonical nav key used in the app */
export function dbKeyToNavKey(dbKey) {
  const raw = String(dbKey || '')
    .replace(/^MENU_/i, '')
    .toLowerCase()
    .replace(/_/g, '-');
  if (raw === 'acadamics') return 'academics';
  return raw;
}

export function navKeyToDbKey(navKey) {
  return `MENU_${String(navKey).toUpperCase().replace(/-/g, '_')}`;
}

/** Build flat visibility map from API menu settings object */
export function buildVisibilityFromApi(menuObj) {
  const fromDb = {};
  Object.entries(menuObj || {}).forEach(([dbKey, val]) => {
    const navKey = dbKeyToNavKey(dbKey);
    if (!navKey) return;
    const hidden = val === false || val === 0 || val === '0' || val === 'false';
    const visible = !hidden;
    if (fromDb[navKey] === false) fromDb[navKey] = false;
    else fromDb[navKey] = visible;
  });

  const flat = {};
  PUBLIC_NAV_MENU.forEach((parent) => {
    flat[parent.key] = fromDb[parent.key] !== false;
    (parent.submenu || []).forEach((sub) => {
      flat[sub.key] = fromDb[sub.key] !== false;
    });
  });
  return flat;
}

/** All keys to persist (canonical only) */
export function allNavVisibilityKeys() {
  const keys = new Set();
  PUBLIC_NAV_MENU.forEach((parent) => {
    keys.add(parent.key);
    (parent.submenu || []).forEach((sub) => keys.add(sub.key));
  });
  return [...keys];
}
